import React from "react";
import InputField from "../InputField";

const ConfirmAadhaar = ({
  confirmedAadhaar,
  handleReEnter,
  confirmedAadhaarError,
}) => {
  return (
    <div className="row">
      <div className="col-sm-4 col-md-12 col-xl-4">
        <div className={"form-group"}>
          <InputField
            inputType={1}
            inputName={"confirm_aadhaar"}
            inputValue={confirmedAadhaar}
            inputDocId={null}
            isInputMandatory={1}
            inputLabel={"Re-enter Aadhaar Number"}
            handleOnChange={(e) => handleReEnter(e.target.value)}
          />
          {confirmedAadhaarError && (
            <p className="text-danger">Aadhaar numbers don't match</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmAadhaar;
